import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Dialog } from '@material-ui/core';
import assignIn from 'lodash/assignIn';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import { FormattedMessage } from 'react-intl';
import { useHover } from 'react-use';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { Configure } from 'components/content/Algolia';
import { SearchBoxFilter, SelectFilter } from 'components/content/ContentList/Filters';
import { AlgoliaSearchItemList } from 'components/content/SearchItemList';
import { useSiteConfig } from 'libs/common/hooks';
import { useAlgoliaSearchClient } from 'libs/content/hooks';
import { getAlgoliaLinkableContentTypeFilter } from 'libs/content/utils';
import { LinkAttributeValue } from 'types/content/Link';
import { ContentPreview } from './ContentPreview';
import { ButtonContainer, CloseButton, Description, FiltersContainer, SearchBoxWrapper, Title } from './InternalLinkDialog.style';

var InternalLinkDialog = function InternalLinkDialog(_ref) {
  var _initialLinkData$sele;

  var initialLinkData = _ref.initialLinkData,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useState = useState(function () {
    return assignIn({
      contentId: '',
      attributes: {
        target: '',
        rel: ''
      }
    }, initialLinkData);
  }),
      linkData = _useState[0],
      setLinkData = _useState[1];

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var linkableContentTypesFilter = getAlgoliaLinkableContentTypeFilter(site);

  var _useAlgoliaSearchClie = useAlgoliaSearchClient(),
      searchClient = _useAlgoliaSearchClie.searchClient,
      sortingIndexNames = _useAlgoliaSearchClie.sortingIndexNames;

  var isLinkSelected = useMemo(function () {
    return linkData.contentId !== '';
  }, [linkData]);
  var isNoFollow = useMemo(function () {
    return linkData.attributes.rel === LinkAttributeValue.RelNoFollow;
  }, [linkData.attributes.rel]);
  var isTargetBlank = useMemo(function () {
    return linkData.attributes.target === LinkAttributeValue.TargetBlank;
  }, [linkData.attributes.target]);
  var initialRefinement = (_initialLinkData$sele = initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.selectedText) !== null && _initialLinkData$sele !== void 0 ? _initialLinkData$sele : '';
  var toggleNofollow = useCallback(function () {
    return setLinkData(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        attributes: _objectSpread(_objectSpread({}, currentState.attributes), {}, {
          rel: isNoFollow ? undefined : LinkAttributeValue.RelNoFollow
        })
      });
    });
  }, [isNoFollow]);
  var toggleTargetBlank = useCallback(function () {
    return setLinkData(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        attributes: _objectSpread(_objectSpread({}, currentState.attributes), {}, {
          target: isTargetBlank ? undefined : LinkAttributeValue.TargetBlank
        })
      });
    });
  }, [isTargetBlank]);
  useEffect(function () {
    if (initialLinkData !== undefined) {
      setLinkData(initialLinkData);
    }
  }, [initialLinkData]);
  var handleConfirm = useCallback(function () {
    if (linkData.contentId !== '') {
      onConfirm(linkData);
    }
  }, [linkData, onConfirm]);

  var onItemClicked = function onItemClicked(item) {
    setLinkData(function (currentState) {
      var _item$previewImage;

      return _objectSpread(_objectSpread({}, currentState), {}, {
        contentId: item.id,
        label: item.label,
        previewUrl: (_item$previewImage = item.previewImage) !== null && _item$previewImage !== void 0 ? _item$previewImage : '',
        attributes: {}
      });
    });
  };

  var resetSelectedLink = useCallback(function () {
    return setLinkData(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        contentId: ''
      });
    });
  }, []);
  var preview = useCallback(function (hovered) {
    var _linkData$previewUrl;

    return __jsx("div", null, __jsx(ContentPreview, {
      isNoFollow: isNoFollow,
      isTargetBlank: isTargetBlank,
      linkData: {
        label: linkData.label,
        previewUrl: (_linkData$previewUrl = linkData.previewUrl) !== null && _linkData$previewUrl !== void 0 ? _linkData$previewUrl : ''
      },
      resetSelectedLink: resetSelectedLink,
      toggleNofollow: toggleNofollow,
      toggleTargetBlank: toggleTargetBlank,
      hovered: hovered
    }));
  }, [isNoFollow, isTargetBlank, linkData, resetSelectedLink, toggleNofollow, toggleTargetBlank]);

  var _useHover = useHover(preview),
      _useHover2 = _slicedToArray(_useHover, 1),
      HoverablePreview = _useHover2[0];

  if (!searchClient) {
    return null;
  }

  return __jsx(Dialog, {
    open: true,
    onClose: onClose,
    disableRestoreFocus: true,
    "data-testid": "internal-link-dialog"
  }, __jsx(CloseButton, {
    onClick: onClose,
    "data-testid": "close-button"
  }), __jsx(FormattedMessage, {
    id: "internal-link-modal.title",
    tagName: Title
  }), isLinkSelected ? HoverablePreview : __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "internal-link-modal.description",
    tagName: Description
  }), __jsx(InstantSearch, {
    indexName: sortingIndexNames.modificationDate.desc,
    searchClient: searchClient
  }, __jsx(FiltersContainer, null, __jsx(SearchBoxWrapper, null, __jsx(SearchBoxFilter, {
    fieldLabelId: "filters.search",
    defaultRefinement: initialRefinement
  })), __jsx(SelectFilter, {
    attribute: "contentType",
    fieldLabelIdPrefix: "filters.content-type",
    limit: 50
  })), __jsx(Configure, {
    hitsPerPage: 15,
    filters: linkableContentTypesFilter
  }), __jsx(AlgoliaSearchItemList, {
    onClick: onItemClicked
  }))), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: !isLinkSelected,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "internal-link-modal.confirm"
  }))));
};

export default InternalLinkDialog;